import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { DiagnosisSection } from './components/DiagnosisSection';
import { OfferSection } from './components/OfferSection';
import { PricingSection } from './components/PricingSection';
import { DifferentiatorSection } from './components/DifferentiatorSection';
import { SocialProofSection } from './components/SocialProofSection';
import { FaqSection } from './components/FaqSection';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-nova-navy-dark text-white font-sans selection:bg-nova-gold selection:text-nova-navy-dark" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <DiagnosisSection data-id="element-4" />
        <OfferSection data-id="element-5" />
        <PricingSection data-id="element-6" />
        <DifferentiatorSection data-id="element-7" />
        <SocialProofSection data-id="element-8" />
        <FaqSection data-id="element-9" />
        <FinalCta data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}